import { useState, useContext } from "react";
import WizardContext from "./WizardContext";

/**
 * useRuntimeField - Manages field state synced with runtimeVariables (not emitted)
 * @param {string} fieldName - The key in runtimeVariables to sync with
 * @param {any} defaultValue - Default value if not in runtimeVariables
 * @returns {[value, setValue]} - Like useState, but auto-synced to runtimeVariables
 */
const useRuntimeField = (fieldName, defaultValue) => {
    const context = useContext(WizardContext);

    const [value, setValue] = useState(
        context.runtimeVariables?.[fieldName] ?? defaultValue
    );

    // Sync runtimeVariables when local state changes
    const setRuntimeValue = (newValue) => {
        setValue(newValue);
        const newVariables = {
            ...context.runtimeVariables,
            [fieldName]: newValue,
        };
        context.setRuntimeVariables(newVariables);
    };

    return [value, setRuntimeValue];
};

export default useRuntimeField;
